import React from 'react'

import { Link } from 'gatsby-plugin-intl';
import { getCurrentLangKey } from '../../utils/getCurrentLangKey';
import { getLinkPrefix } from '../../utils/getLinkPrefix';

import { CategoryTag } from '../CategoryTag';

export const BoxSection = ({ data, type, t, country_code }) => {
  const langKey = getCurrentLangKey();
  return (
    <div className="block-xs">
      <div className="container">
        {(type === "featured_topics") ? (
          <div className="featured-topics">
            <h3>{t.home_featured_topics}</h3>
            <div className="row margin-top-sm">
              {data.featured.map(post => {
                const localized_post = post.localizations.find(item => item.locale === langKey) || post;
                return (
                  <div className="col-md-4" key={post.id}>
                    <Link to={getLinkPrefix('articles', `${post.slug}`)} language={langKey} className="border-box">
                      {post.categories.map(category => {
                        const localized_category = category.localizations.find(item => item.locale === langKey) || category;
                        return (
                          <CategoryTag key={category.id} type={localized_category.Name} tag_color={category.tag_color}>
                            {localized_category.tag || localized_category.Name}
                          </CategoryTag>
                        )
                      })}
                      <h4>{localized_post.title}</h4>
                      <p>{localized_post.excerpt?.substring(0, 100) || localized_post.sub_title?.substring(0, 100)}...</p>
                      <button type="button" className="btn btn-default">{t.read_more}</button>
                    </Link>
                  </div>
                )
              })}
            </div>
          </div>
        ) : null}


        {(type === "browse_resources") ? (
          <div className="browse-resources">
            <h3>{t.home_browse_resources}</h3>
            <div className="row margin-top-sm">
              {data.browse_resources.map(category => {
                const localized_category = category.localizations.find(item => item.locale === langKey) || category;
                return (
                  <div className="col-md-4" key={category.id}>
                    {localized_category.external_link ?
                      <a href={localized_category.link} title={localized_category.Name} className="border-box">
                        <img src={`/support-center/api${localized_category.icon.url}`} className="resource-icon" alt={category.Name}/>
                        <h4>{localized_category.Name}</h4>
                        <p>{localized_category.description?.substring(0, 100)}...</p>
                      </a>
                      :
                      <Link to={getLinkPrefix('categories', `${localized_category.link}`)} language={langKey} className="border-box">
                        <img src={`/support-center/api${category.icon.url}`} className="resource-icon" alt={category.Name}/>
                        <h4>{localized_category.Name}</h4>
                        <p>{localized_category.description?.substring(0, 100)}...</p>
                      </Link>
                    }
                  </div>
                )
              })}
            </div>
          </div>
        ) : null}

      </div>
    </div>
  )
}

